import {
  createFileRoute,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { Button, ContentWrapper } from '~/components/elements'
import { ArrowBackIosOutlineIcon } from '~/components/icons'
import { DiagnosticResult } from '~/components/service/DiagnosticResult'

export const Route = createFileRoute('/_authenticated/service/result')({
  component: ServiceTestResultPage,
})

function ServiceTestResultPage() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <ContentWrapper>
      <div style={{ marginBottom: '24px' }}>
        <Button
          size="small"
          variant="secondary"
          onClick={() => navigate({ to: '/service/service-tests' })}
        >
          <ArrowBackIosOutlineIcon /> Back
        </Button>
      </div>
      <DiagnosticResult data={location.state.data} serviceType="nbn" />
    </ContentWrapper>
  )
}
